const CheckIcon = ({ color = '#4F5E75' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="m5.525 10.682 4.95-4.95a1 1 0 0 1 1.414 1.414l-4.95 4.95-1.414-1.414z" fill={color} />
    <path d="M4.11 7.854a1 1 0 0 1 1.415 0l2.828 2.828-1.414 1.414-2.828-2.828a1 1 0 0 1 0-1.414z" fill={color} />
  </svg>
);

export default CheckIcon;
